import { render, staticRenderFns } from "./course-plate-nopay.vue?vue&type=template&id=4ca56653&scoped=true&"
import script from "./course-plate-nopay.vue?vue&type=script&lang=js&"
export * from "./course-plate-nopay.vue?vue&type=script&lang=js&"
import style0 from "./course-plate-nopay.vue?vue&type=style&index=0&id=4ca56653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca56653",
  null
  
)

export default component.exports